import {
    Alert as MuiAlert,
    IconButton, Collapse,
    Icon, Typography
} from '@mui/material'

import { forwardRef } from 'react'

export const Alert = forwardRef((props, ref) => {
    const haveConfig = (props.config)
    const controlled = props.controlled ?? false

    const fill = `${props.config?.fill ?? (props.fill || '1')}`
    const severity = props.config?.severity ?? (props.severity || 'info')
    const elevation = props.config?.elevation ?? (props.elevation || 0)
    const title = props.config?.title ?? (props.title || null)
    const icon = props.config?.icon ?? (props.icon || null)
    
    const onClose = () => {
        if (props.onClose && (typeof props.onClose === 'function'))
            props.onClose()
    }

    const cmp = (
        <MuiAlert
            sx={props.sx || {}}
            ref={ref}
            elevation={elevation}
            severity={severity}
            action={
                ((haveConfig && props.config.closable) || (props.onClose && props.closable)) && (
                    <IconButton className={'close-icon'} size="small" onClick={onClose}>
                        <Icon>close</Icon>
                    </IconButton>
                )
            }
            iconMapping={{
                success: (<Icon sx={{fontVariationSettings: `'FILL' ${fill}`}}>{icon || 'check_circle'}</Icon>),
                info: (<Icon sx={{fontVariationSettings: `'FILL' ${fill}`}}>{icon || 'info'}</Icon>),
                warning: (<Icon sx={{fontVariationSettings: `'FILL' ${fill}`}}>{icon || 'warning'}</Icon>),
                error: (<Icon sx={{fontVariationSettings: `'FILL' ${fill}`}}>{icon || 'report_problem'}</Icon>)
            }}
        >
            {title && (<Typography variant={props.variant || 'h6'}>{title}</Typography>)}
            {props.children || (<Typography variant={props.variant || 'body2'}>{props.config?.label ?? (props.label || props.description || '')}</Typography>)}
        </MuiAlert>
    )

    if (controlled) {
        return (
            <Collapse in={(haveConfig) ? props.config.open : true} timeout={200} sx={{width: '100%'}}>
                {cmp}
            </Collapse>
        )
    }

    return (cmp)
})

Alert.displayName = 'Alert'

export default Alert